import React from 'react';
import { Button } from 'react-bootstrap';
import { STATUS } from 'Utils/styleTokens';
import { RunningJobStatus } from './RunningJobRow';
import { useCanEdit, READ_ONLY_TITLE } from 'Auth/permissions';

/**
 * Block-level twin of {@link RunningJobRow} for a page that is waiting on one job rather than
 * listing many (e.g. the Data Graph while its Profile runs): the same running dot, progress bar
 * and "N of M <unit> · P%", the same status pill and Cancel, on the same info background.
 *
 * @param status     pill text (default "RUNNING"; pass "QUEUED" for a PENDING job)
 * @param note       optional trailing text, e.g. what happens when the job completes
 * @param onCancel   omit to hide the button
 * @param testId     the bar's data-testid (`${testId}-progress`, `${testId}-cancel` inside)
 */
function RunningJobBar({ jobType, status, completed, total, unit, note, onCancel, cancelling, testId }) {
  const canEdit = useCanEdit();
  return (
    <div
      data-testid={testId}
      className='d-flex align-items-center flex-wrap'
      style={{ gap: 12, padding: '9px 12px', borderRadius: 8, background: STATUS.info.bg, border: '1px solid var(--ink-100)', textAlign: 'left' }}
    >
      <span className='d-inline-flex align-items-center flex-wrap' style={{ gap: 0 }}>
        <RunningJobStatus jobType={jobType} completed={completed} total={total} unit={unit} testId={testId} />
      </span>
      <span className='sg-pill sg-pill--info' style={{ fontSize: 10.5 }}>{status || 'RUNNING'}</span>
      {note && <span style={{ color: 'var(--ink-500)', fontSize: 12 }}>{note}</span>}
      {onCancel && (
        <Button size='sm' variant='outline-danger' className='ml-auto' disabled={cancelling || !canEdit} onClick={onCancel}
          title={!canEdit ? READ_ONLY_TITLE : undefined}
          data-testid={testId ? `${testId}-cancel` : undefined}>
          {cancelling ? 'Cancelling…' : 'Cancel'}
        </Button>
      )}
    </div>
  );
}

export default RunningJobBar;
